import { Lifebuoy, Phone, ArrowUpRight } from "@phosphor-icons/react";

const RESOURCES = [
  {
    name: "Postpartum Support International",
    tag: "Perinatal mental health, including loss",
    action: "1-800-944-4773 · text 800-944-4773",
    href: "https://www.postpartum.net/get-help/loss-grief-in-pregnancy-postpartum/",
  },
  {
    name: "Star Legacy Foundation",
    tag: "Stillbirth research, prevention, and family support",
    action: "starlegacyfoundation.org",
    href: "https://starlegacyfoundation.org/",
  },
  {
    name: "988 Suicide & Crisis Lifeline",
    tag: "For any moment that feels too heavy, call or text",
    action: "Call or text 988",
    href: "https://988lifeline.org/",
  },
];

export default function CrisisResources() {
  return (
    <div className="bg-white border border-coral-100 rounded-2xl p-6 shadow-soft" data-testid="crisis-resources">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-coral-50 border border-coral-100 grid place-items-center shrink-0">
          <Lifebuoy size={20} weight="duotone" className="text-coral-700" />
        </div>
        <div className="flex-1">
          <div className="text-xs tracking-[0.2em] uppercase text-coral-700">If you're in crisis</div>
          <div className="font-display text-xl mt-1 leading-snug">You do not have to sit with this alone.</div>
          <p className="text-sm text-ink/70 mt-2 leading-relaxed">
            These trained humans specialize in reproductive loss and perinatal mental health.
            Reach out any time, day or night, first hour or fifth year.
          </p>
        </div>
      </div>
      <div className="mt-5 grid sm:grid-cols-3 gap-3">
        {RESOURCES.map((r) => (
          <a key={r.name} href={r.href} target="_blank" rel="noopener noreferrer"
             data-testid={`resource-${r.name.split(' ').join('-').toLowerCase()}`}
             className="group block p-4 rounded-xl border border-border bg-cream/60 hover:border-coral hover:bg-white transition-colors">
            <div className="flex items-start justify-between gap-2">
              <Phone size={16} weight="duotone" className="text-sage" />
              <ArrowUpRight size={14} className="text-muted-foreground group-hover:text-coral-700 transition-colors" />
            </div>
            <div className="font-display text-sm mt-2 leading-snug">{r.name}</div>
            <div className="text-[11px] text-muted-foreground mt-1 leading-relaxed">{r.tag}</div>
            <div className="text-xs text-coral-700 mt-2 font-medium">{r.action}</div>
          </a>
        ))}
      </div>
    </div>
  );
}
